import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header";
import Footer from "../layout/footer";

const bg = require("../../images/servicehero.png");

class MedicalCleaning extends Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr  bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">School And Medical Cleaning</h1>
                <div className="breadcrumb-row">
                  {/* <ul className="list-inline">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>Service</li>
                    <li>Service Details</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-5">
                    <div className="widget sidebar-widget ext-sidebar-menu widget_nav_menu">
                      <ul className="menu">
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/airbnb-cleaning"
                          >
                            Airbnb Property Management
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/residential-cleaning"
                          >
                            Residential Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/office-cleaning"
                          >
                            Office Cleaning
                          </Link>{" "}
                        </li>
                        <li className="active">
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/school-and-medical-cleaning"
                          >
                            School And Medical Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/bond-cleaning"
                          >
                            Bond Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/window-cleaning"
                          >
                            Window Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/special-event-cleaning"
                          >
                            Special Event Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/carpet-steam-cleaning"
                          >
                            Carpet Steam Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/spring-cleaning"
                          >
                            Spring Cleaning
                          </Link>{" "}
                        </li>
                      </ul>
                    </div>
                    {/* <div className="widget">
                      <div className="download-file">
                        <h4 className="title">Get your brochures</h4>
                        <ul>
                          <li>
                            <Link to="#" target="_blank">
                              <div className="text">Company Brochures</div>
                              <i className="fa fa-download"></i>
                            </Link>
                          </li>
                          <li>
                            <Link to="#" target="_blank">
                              <div className="text">Company Info</div>
                              <i className="fa fa-download"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                  </div>
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        {/* <div className="dlab-media">
                            {" "}
                            <Link to="#">
                              <img
                                src={require("../../images/about/pic4.jpg")}
                                alt=""
                              />
                            </Link>{" "}
                          </div> */}
                        <div className="dlab-info ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Why Do Schools and Medical Centers Need to Seek
                              the Assistance of Professional Cleaners?
                            </Link>
                          </h4>
                          <p>
                            One of the most challenging careers is caring for
                            and educating young children. Providing an ideal
                            cleaner environment to guarantee a hygienic learning
                            environment meeting standards is paramount.
                          </p>
                          <p>
                            Professional school cleaning services use
                            hospital-grade disinfectants and have color coded to
                            equipment to ensure there is no cross-contamination,
                            and use eco-friendly products to provide:
                          </p>
                          <ul className="list-angle-right">
                            <li>Carpet and deep floor cleaning</li>
                            <li>Window cleaning</li>
                            <li>
                              Cleaning frequently touched surfaces such as door
                              handles, elevator buttons, handrails, computers,
                              cupboard handles, etc.
                            </li>
                            <li>School exterior cleaning</li>
                            <li>Fan and ceiling cleaning</li>
                            <li>Bathroom sanitation</li>
                          </ul>

                          <p>
                            More than ever, it is imperative to lower the danger
                            of contamination and the transmission of harmful
                            pathogens, including COVID-19. Healthcare facilities
                            are one such premise that requires this attention. A
                            key aim is establishing and preserving a peaceful
                            and compassionate environment for patients.
                            Continuous cleaning is crucial to provide this
                            environment. Both your patients and your team
                            require the assurance of a hygienically secure
                            clinical medical environment.
                          </p>

                          <p>
                            To maintain consistent compliance with cleanliness,
                            you require the services of an experienced medical
                            cleaning company.
                          </p>
                          <p>
                            Specialists in medical cleaning know the standards
                            to provide healthcare clients as they have a keen
                            knowledge about it.{" "}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="dlab-box">
                      <div className="dlab-info m-t30">
                        <h4 className="dlab-title m-t0">
                          <Link to="#">Cleaning VS Disinfection</Link>
                        </h4>
                        <p>
                          Cleaning is physically removing contaminants,
                          including dirt, filth, and viruses like SARS-CoV-2
                          (the virus that causes COVID-19), and eliminating dirt
                          off surfaces with warm water and detergent. A surface
                          must first be cleaned before disinfection can be done.
                        </p>
                        <p>
                          A detergent is a type of surfactant used in water to
                          dissolve oil and grease. An effective physical
                          cleaning involves using combined detergents and
                          Therapeutic Goods Administration (TGA) registered
                          hospital-grade disinfectant or a chlorine-based
                          product such as sodium hypochlorite or equivalent for
                          use in school environments.
                        </p>
                        <p>
                          Using chemicals to eradicate germs from surfaces or
                          items is known as disinfecting.
                        </p>
                        <p>
                          After cleaning, eradicating germs on a surface can
                          help reduce the likelihood of an infection spreading.{" "}
                        </p>
                        <p>
                          Professional cleaners clean first before disinfection
                          because grit might interfere with the effectiveness of
                          disinfectants in killing bacteria.
                        </p>
                      </div>
                    </div>
                    <div className="dlab-info m-t30 ">
                      <h4 className="dlab-title m-t0">
                        <Link to="#">Schedule your Free Appointment!</Link>
                      </h4>
                      <p>
                        If you are looking for professionally experienced school
                        or medical cleaners based in Surfers Paradise or close
                        to Gold Coast, Queensland, you are in the right place!
                        We service clients in all areas of Gold Coast from Main
                        Beach, Southport, Nerang to Varsity Lakes.
                      </p>
                      <p>
                        At Gold Coast Kangaroo Shine Property Services in Gold
                        Coast, QLD, we provide medical and school cleaning and
                        disinfection for childcare centers, primary schools,
                        high schools, colleges or universities, and medical
                        centers, including hospitals, to provide a safer and
                        healthier environment.
                      </p>
                      <p>
                        Our specialized Gold Coast Kangaroo Shine Property
                        Services team focuses on eliminating contaminants from
                        your entire school and hospital using non-toxic quality
                        cleaning products.
                      </p>
                      <p>
                        Contact us for a quote at +61424888804, and our team at
                        Kangaroo Shine Property Services in Gold Coast will help
                        you establish a healthier environment for your clients!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
export default MedicalCleaning;
